import { getCsrfToken } from "./csrf";

type JsonRequestOptions = {
  body?: unknown;
  method?: "POST" | "PATCH" | "PUT" | "DELETE";
};

export class RequestError extends Error {
  readonly status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = "RequestError";
    this.status = status;
  }
}

async function serverErrorMessage(response: Response): Promise<string> {
  try {
    const payload = (await response.clone().json()) as { error?: unknown };
    if (typeof payload.error === "string" && payload.error.trim()) {
      return payload.error;
    }
  } catch {
    // response body was not JSON - fall through to the generic message
  }
  return `Request failed with status ${response.status}`;
}

export async function requestJson<T>(url: string, options: JsonRequestOptions = {}): Promise<T> {
  const request: RequestInit = {
    method: options.method ?? "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": getCsrfToken(),
    },
  };

  if (options.body !== undefined) {
    request.body = JSON.stringify(options.body);
  }

  const response = await fetch(url, request);

  if (!response.ok) {
    throw new RequestError(response.status, await serverErrorMessage(response));
  }

  return response.json() as Promise<T>;
}

export async function postWithoutBody(url: string) {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "X-CSRF-Token": getCsrfToken(),
    },
  });

  if (!response.ok) {
    throw new RequestError(response.status, await serverErrorMessage(response));
  }
}
